import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import useClasses from '../../hooks/useClasses';
import { MediaFileField } from '../../types';

import './style.scss';

interface Props {
  image: ImmutableEntity<MediaFileField>;
  size?: 'xs' | 's' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
}

const Badge: React.FC<Props> = ({ image, size, className }) => {
  const { buildClass, joinClasses } = useClasses('Badge');

  return (
    <div className={joinClasses(buildClass(), { [`badge-size-${size}`]: size }, className)}>
      <img src={image.get('url')} alt={image.get('description')} />
    </div>
  );
};

export default Badge;
